<!-- Input de telefone

//utilização:
  <input-fone
    v-on:update="updateCep"
    name="fone"
    v-model="entity.part.fone"
    v-validate="{numeric: true, min: 2, max: 15}"></input-fone>

//eventos emit
v-on:update

-->

<template>
    <input
      type="text"
      :value="fone"
      @focus="handleFocus"
      @input="updateValue($event.target.value)"
      @blur="handleBlur"
      @keyup.esc="handleEsc"
      @keydown.enter="handleEnter"
      @keydown.tab="handleKeyTab"
      @keyup.down="handleKeyDown"
      @keyup.up="handleKeyUp"
      ref="fone"
      maxlenght="15"
      placeholder="(00) 0000-0000">
</template>

<script>
//https://br.vuejs.org/v2/guide/components.html#Usando-v-on-com-Eventos-Personalizados

import { SysVars } from '../main';
import { hasHiddenParent } from '../shared/utils';

export default {
    props: {
      'value': String
    },

    data () {
      return {
        fone: this.value,
        fucused: false
      }
    },
    created () {

    },

    watch: {
      value: function (newValue) {
        this.fone = newValue
        this.$nextTick(function () {
          this.formatValue()
        })
      }
    },

    methods: {
        handleKeyTab () {
            this.$emit('keydowntab')
        },

        handleBlur () {
            this.formatValue()
            this.$emit('blur')
        },

        handleEsc() {
            this.$emit('keyupesc')
        },

        handleEnter (event) {
          this.focusControl(event)
          this.$emit('keyupenter')
        },

        handleKeyDown () {
            this.$emit('keyupdown')
        },

        handleKeyUp () {
            this.$emit('keyupup')
        },

      updateValue: function(value) {
        this.fone = value.replace(/\D/g, '')
        this.$emit('input', this.fone)
      },

      formatValue: function() {
        this.focused = false
        if (this.$refs.fone.value) {
          this.$refs.fone.value = this.$formatFone(this.$refs.fone.value)
        }
      },

      handleFocus: function(event) {
        this.formatRemove()
        this.focused = true
        // Workaround for Safari bug
        // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
        this.$emit('focus')
        setTimeout(function() {
          event.target.select()
        }, 0)
      },

      formatRemove: function () {
        if (this.$refs.fone.value) {
          this.$refs.fone.value = this.fone.replace(/\D/g, '')
        }
      },

      focusControl: function (event) {
          event.preventDefault();
          var thisIndex = jQuery(this.$el).index(SysVars.sFocusControl)
          var next = thisIndex + 1
          var obj = jQuery(SysVars.sFocusControl)
          let found = false
          for (var x = next; x < obj.length; x++) {
            if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
              jQuery(obj[x]).focus()
              found = true
              break
            }
          }
          if (!found) {
            for (var x = 0; x < obj.length; x++) {
              if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
                jQuery(obj[x]).focus()
                found = true
                break
              }
            }
          }

          this.$emit('keyenter')
      },

      focus: function () {
          if (this.$refs.fone) {
              this.$refs.fone.focus()
          }
      },

    },

}
</script>

<style scoped>
  input {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/input-fone.vue